export const PROJECTS_PAGE_SIZE = 12;
export const IMAGES_PAGE_SIZE = 12;

/** Projetos recentes no dashboard (não é a listagem paginada). */
export const DASHBOARD_RECENT_PROJECTS = 3;

export const INVOICES_INITIAL_PAGE_SIZE = 5;
export const INVOICES_LOAD_MORE_PAGE_SIZE = 5;
